import config from '.';

// eslint-disable-next-line no-eq-null, eqeqeq
if (config.cdnBaseUrl != null) {
	// eslint-disable-next-line no-inline-comments, line-comment-position, spaced-comment, camelcase, id-match, no-undef
	__webpack_public_path__ = config.cdnBaseUrl; //NOSONAR
}
